export default {
  label: "Label",
  addLabel: "AddLabel",
  editLabel: "EditLabel",
};
